module.exports = __webpack_public_path__ + "static/media/hopster-logo-white.c9efc700.svg";